<template>
 <type-form :group-type="newType"></type-form>
</template>

<script>

import TypeForm from './typeForm'
import {GroupType} from '../../../../object'
export default {
  name: 'NewGroupType',
  components: {TypeForm},
  data: () => ({
    newType: new GroupType()
  })
}
</script>

<style scoped>

</style>
